export default __webpack_public_path__ + "images/corporatebrandmark.svg";